import React from "react"
import styles from "./SearchBox.scss"

const SearchBox = ({title, filter, setFilter, filterTitle}) => (
	<div className={styles.searchBox}>
		<h2>{title}</h2>
		<div className={styles.searchContainer}>
			<div className={`${styles.searchLogo}`}></div>
            <input
                autoFocus
                placeholder={filterTitle}
                className={`${styles.mainSearch} ${styles.leftLogo}`}
                value={filter}
                onChange={ev => setFilter(ev.target.value)}
                onFocus={(e)=>{
                    // the following to move caret at the end
                    let temp_value = e.target.value
                    e.target.value = ''
                    e.target.value = temp_value
                }}
			/>
			{filter && <div onClick={() => setFilter()} className={styles.removeFilter}>
				<span className={styles.cross}>&times;</span>
			</div>}
		</div>
	</div>
)
SearchBox.propTypes = {
	content: React.PropTypes.string,
}

export default SearchBox



// WEBPACK FOOTER //
// ./elements/SearchBox.jsx